var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPackBtn)?_c('v-btn',{attrs:{"color":"blue-grey","small":"","outline":""},on:{"click":function($event){return _vm.goTo('newParcel', { shipmentId: _vm.shipment.id })}}},[_vm._v("\n       "+_vm._s(_vm.$t('pack'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }